module.exports = __webpack_public_path__ + "static/media/DSC_0079.9dde56be.jpg";